import { getRequest, postRequest } from "../libs/AxiosService.util";

export const STAFF_TYPE = {
  ADMIN: "ADMIN",
  LEAD: "LEAD",
  TELECALLER: "TELECALLER",
};

export async function serviceGetStaffList(params) {
  return await postRequest("admins", params);
}
export async function serviceCreateStaff(params) {
  return await postRequest("admins/create", params);
}
export async function serviceUpdateStaff(params) {
  return await postRequest("admins/update", params);
}
export async function serviceGetStaffDetails(params) {
  return await postRequest("admins/details", params);
}
export async function serviceDeleteStaff(params) {
  return await postRequest("admins/delete", params);
}
export async function serviceGetTeamByManager(params) {
  return await postRequest("admins/team-by-manager", params);
}

/** Check if email already exists (for admin users / employees). Pass id on update to exclude current user. */
export async function serviceCheckEmailExists(email, id = null) {
  return await postRequest("admins/check-email", { email: email || undefined, id: id || undefined });
}

/** Check if employee_id already exists. Pass id on update to exclude current user. */
export async function serviceCheckEmployeeIdExists(employee_id, id = null) {
  return await postRequest("admins/check-employee-id", { employee_id: employee_id || undefined, id: id || undefined });
}

export async function serviceGetAdminUser(params) {
  return await postRequest("doctors/professionals/list", params);
}
export async function serviceGetAdminUserDetail(params) {
  return await postRequest("doctors/professional/details", params);
}
export async function serviceGetAdminUserCalendarDetail(params) {
  return await postRequest("doctors/available-days", params);
}
export async function serviceExportAdminUser(params) {
  return await postRequest("doctors/professionals/list/export", params);
}
export async function serviceGetAdminUserList(list, otherParams = {}) {
    return await postRequest('list', { list: list, ...otherParams, });
}
export async function serviceCreateDoctorAvailabilty(params) {
    return await postRequest('doctors/create-availability',params);
}
export async function serviceGetConfigSlotDoctor(params) {
  return await getRequest("doctors/slots/config", params);
}
export async function serviceDoctorAvailabilty(params) {
    return await postRequest('doctors/availability',params);
}
export async function serviceDoctorAvailabilityByDoctors(params) {
    return await postRequest('doctors/availability/by/doctors',params);
}
export async function serviceCreateAdminUser(params) {
    return await postRequest('doctors/create/professional', params);
}
export async function serviceGetCommonSalesEmployee(params) {
  return await postRequest("list", params);
}
export async function serviceExportDoctorAvailability(params) {
  return await postRequest("doctors/availability/by/doctors/export");
}

export async function serviceGetDoctorWalletLedgers(params) {
  return await postRequest("doctors/wallet/ledger", params);
}

